import React, { useContext } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import ConfigContext from '../../contexts/ConfigContext';

import 'slick-carousel/slick/slick.css';
import styles from './FeaturedCuisines.module.postcss';

const defaultSettings = {
  slidesToShow: 5,
  slidesToScroll: 2,
  infinite: false,
  lazyLoad: 'anticipated',
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 732,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

const cuisineList = [
  {
    name: 'Pizza',
    link: '/food-truck-catering/pizza-catering',
    image: 'https://static.seattlefoodtruck.com/photos/pizza1-sm.webp',
  },
  {
    name: 'BBQ',
    link: '/food-truck-catering/bbq-catering',
    image: 'https://static.seattlefoodtruck.com/photos/bbq1-sm.webp',
  },
  {
    name: 'Taco',
    link: '/food-truck-catering/taco-catering',
    image: 'https://static.seattlefoodtruck.com/photos/Taco_Header-sm.webp',
  },
  {
    name: 'Asian',
    link: '/food-truck-catering/asian-catering',
    image: 'https://static.seattlefoodtruck.com/photos/new-asian-header-sm.webp',
  },
  {
    name: 'Burger',
    link: '/food-truck-catering/burger-catering',
    image: 'https://static.seattlefoodtruck.com/photos/burger1-sm.webp',
  },
  {
    name: 'Dessert',
    link: '/food-truck-catering/dessert-catering',
    image: 'https://static.seattlefoodtruck.com/photos/dessert1-sm.webp',
  },
  {
    name: 'Breakfast',
    link: '/food-truck-catering/breakfast-catering',
    image: 'https://static.seattlefoodtruck.com/photos/catering-header-sm.webp',
  },
  {
    name: 'Wedding',
    link: '/food-truck-catering/wedding-catering',
    image: 'https://static.seattlefoodtruck.com/photos/catering5-sm.webp',
  },
  {
    name: 'Corporate',
    link: '/food-truck-catering/corporate-catering',
    image: 'https://static.seattlefoodtruck.com/photos/catering2-sm.webp',
  },
  {
    name: 'Birthday',
    link: '/food-truck-catering/birthday-parties',
    image: 'https://static.seattlefoodtruck.com/photos/community-sm.webp',
  },
];

function CuisineTease({ name, link, image }) {
  const { vehicle_type } = useContext(ConfigContext);

  return (
    <div className={styles.CuisineTease}>
      <Link className="u-block" to={link}>

        { image &&
          <img
            className={styles.CuisineTease_image}
            src={image}
            alt={name}
            loading='lazy'
          />
        }

        <div className={styles.CuisineTease_info}>
          <div className='u-strong'>{name} Food {vehicle_type} Catering</div>
        </div>

      </Link>
    </div>
  );
}

function FeaturedCuisines() {
  const { vehicle_type } = useContext(ConfigContext);

  const slides = cuisineList.map((cuisine) => (
    <div key={'cuisine-' + cuisine.name}>
      <CuisineTease name={cuisine.name} link={cuisine.link} image={cuisine.image} />
    </div>
  ));

  return (
    <div className={styles.FeaturedCuisines}>
      <h2>Explore Food {vehicle_type} Catering Options</h2>
      <Slider {...defaultSettings}>
        {slides}
      </Slider>
    </div>
  );
}

export default FeaturedCuisines;
